"use strict";

module.exports = require("./store");


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/store/index.js
 ** module id = 503
 ** module chunks = 0
 **/